import React from "react";
import {withStyles} from "material-ui/styles";
import Typography from "material-ui/Typography";
import {connect} from 'react-redux';
import {compose} from 'recompose';
import styles from "./styles";
import Title from "../ui/title";
import Content from "../ui/content";
import {acceptLocationTracking, getCustomer, cancelLocationTracking} from "../../redux/actions";
import {Button} from "../ui/react-aria/Button";
import {dateTimeFormatter} from "../../common/utils";

class LocationTracking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      acceptedAt: null,
      acceptedByName: null,
    };
  }

  componentDidMount() {
    const {profile, getCustomer} = this.props;
    getCustomer(profile.customerid);
  }

  componentDidUpdate(prevProps) {
    const {customer} = this.props;
    if (prevProps.customer !== customer) {
      this.setState({
        acceptedAt: customer.deviceLocationTrackingAcceptedAt,
        acceptedByName: customer.deviceLocationTrackingAcceptedByName
      });
    }
  }

  accept() {
    const {profile, getCustomer, acceptLocationTracking} = this.props;
    acceptLocationTracking(profile.customerid)
      .then(() => {
        getCustomer(profile.customerid);
      });
  }

  cancel() {
    const {profile, getCustomer, cancelLocationTracking} = this.props;
    cancelLocationTracking(profile.customerid)
      .then(() => {
        getCustomer(profile.customerid);
      });
  }

  render() {
    const {
      translate,
      classes,
      impersonating,
      softwareUpdate,
    } = this.props;

    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }

    const {acceptedAt, acceptedByName} = this.state;

    return (
      <div style={{marginTop: margintop}}>
        <Title title={translate('location_tracking')}/>
        <Content translate={translate}>
          <Typography type="title" className={classes.title}>
            {translate('location_tracking')}
          </Typography>
          {!acceptedAt ?
            <div>
              <p><b>{translate('location_tracking_acceptance_heading')}</b></p>
              <p>{translate('location_tracking_acceptance_intro')}</p>
              <ul>
                <li>{translate('location_tracking_acceptance_data')}</li>
                <li>{translate('location_tracking_acceptance_scope')}</li>
                <li>{translate('location_tracking_acceptance_authority')}</li>
                <li>{translate('location_tracking_acceptance_privacy')}</li>
              </ul>
              <p>{translate('location_tracking_acceptance_confirm')}</p>
              <Button onClick={() => this.accept()}>{translate('location_tracking_accept')}</Button>
            </div> :
            <div>
              {translate('location_tracking_acceptance_confirmed', {
                acceptedByName,
                acceptedAt: dateTimeFormatter(acceptedAt),
              })}
              <p>{translate('location_tracking_cancellation_confirm')}</p>
              <Button onClick={() => this.cancel()}>{translate('cancel')}</Button>
            </div>
          }
        </Content>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customerReducer.customer,
  profile: state.profileReducer.profile,
  ...state,
});

const mapDispatchToProps = (dispatch, props) => ({
  getCustomer: cid => {
    dispatch(getCustomer(cid));
  },
  acceptLocationTracking: customerId => {
    return dispatch(acceptLocationTracking(customerId));
  },
  cancelLocationTracking: customerId => {
    return dispatch(cancelLocationTracking(customerId));
  },
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(LocationTracking);
